export const setSetList = (sets) => ({
    type: 'SET_SETLIST',
    sets
});